export default ({ type, settings }) =>
  (type === "dropdown" && !settings.allowMultipleSelect) || type === "checkbox";
